import { createReducer, on } from '@ngrx/store';
import { loadedVehicles } from './reports.actions';
import { initialState } from './reports.state';

export const reportsReducer = createReducer(
  initialState,
  on(loadedVehicles, (state, { vehicles }) => ({ ...state, vehicles })),
);
